import { render, staticRenderFns } from "./Lgpd.vue?vue&type=template&id=9dc344e4&scoped=true&"
import script from "./Lgpd.vue?vue&type=script&lang=js&"
export * from "./Lgpd.vue?vue&type=script&lang=js&"
import style0 from "./Lgpd.vue?vue&type=style&index=0&id=9dc344e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc344e4",
  null
  
)

export default component.exports